import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'src/store/auth';

import type { LoginRequest } from 'src/services/interfaces/auth';

export const useLogin = () => {
  const { login: loginAction, error, isLoading, clear } = useAuthStore();
  const navigate = useNavigate();

  const handleLogin = async (credentials: LoginRequest) => {
    await loginAction(credentials);

    // Successful authentication should store a token
    if (localStorage.getItem('token')) {
      navigate('/', { replace: true });
    }
  };

  return { clear, login: handleLogin, error, isLoading };
};
